module.exports = __webpack_public_path__ + "img/aiahrn-pcbg.5a86bf2b.png";